// extracted by mini-css-extract-plugin
export default {"wrapper":"pp-z","response":"qp-z","error":"rp-z","disabled":"sp-z","buttons":"tp-z","feedbackQuestionSection":"up-z","yesNoWrapper":"vp-z"};